<template>
    <TableView :heading="__('District wise highest Ambassadors')"
        :headers="[
            { name: __('District'), value: (row) => locale_attr(row, 'district_name_{lang}g') },
            { name: __('Ambassador'), value: (row) => en_to_bn(row.count) }
        ]"
        :rows="ambassadorCounts"
        :pagination="pagination"
        :loading="loading"
        @change:page="fetchCounts" />
</template>

<script>
import axios from 'axios';
import TableView from './TableView.vue';

export default {
    components: {
        TableView,
    },

    data() {
        return {
            ambassadorCounts: [],
            pagination: {
                current_page: 1,
                last_page: 1,
                per_page: 10,
                total: 0,
                from: 0,
                to: 0,
            },
            loading: false,
        }
    },

    mounted() {
        this.observe_visibility(this.$el, () => this.fetchCounts());
    },

    methods: {
        fetchCounts() {
            this.loading = true;
            const params = { page: this.pagination.current_page };
            axios.get('/dashboard/highest-ambassador-count/district', { params })
                .then(({ data }) => {
                    this.ambassadorCounts = data.counts.collection;
                    this.pagination = data.counts.pagination;
                })
                .catch(console.error)
                .finally(() => this.loading = false);
        },
    },
}
</script>